import {Injectable, OnDestroy} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {from as observableFrom, Observable, Subscription} from 'rxjs';
import {PermissionResponse} from "../core/base-api";
import {switchMap} from "rxjs/operators";
import {SecurityData} from "./security-data";
import {AppPermissionService} from "../core/services/app-permission.service";
import {environment} from 'environments/environment';
import {FormatConfigService} from 'app/core/services/format-config.service';
import {CapiLoginService} from 'app/core/extension/login/capi-login-service';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

@Injectable({
  providedIn: 'root'
})
export class AuthorizationGuard implements CanActivate, OnDestroy {

  private subscription: Subscription;

  /*
   * Hack to prevent compile error: _ERROR in TypeError: Cannot read property 'loadChildren' of undefined_
   * See: https://github.com/angular/angular/issues/22700
   */
  static routeConfig(permissions: PermissionsEnum[]): PermissionsEnum[] {
    return permissions;
  }

  constructor(private permissionService: AppPermissionService,
              private loginService: CapiLoginService,
              private router: Router,
              private securityData: SecurityData,
              private appformatConfigService: FormatConfigService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise<boolean>(resolve => {
      this.subscription = observableFrom(this.loginService.requireLogin(state.url)).pipe(
        switchMap(() => this.permissionService.permissions$)).subscribe(userPermissions => {
        this.securityData.actionUrl = state.url;
        const requiredPermissions: PermissionsEnum[] = route.data.permissions;
        if (requiredPermissions && !requiredPermissions.some(permission => userPermissions.includes(permission))) {
          if (this.anonymUserAllowed(userPermissions, requiredPermissions)) {
            resolve(true);
            return;
          }
          if (this.loginService.userLoggedIn && !userPermissions.includes(PermissionsEnum.LOGIN)) {
            this.router.navigate(['unauthorized']);
          } else if (this.loginService.userLoggedIn) {
            this.router.navigate(['security/forbidden']);
          }
          resolve(false);
        }
        resolve(true);
      });
    });
  }

  private anonymUserAllowed(userPermissions: PermissionResponse.PermissionsEnum[], requiredPermissions: PermissionsEnum[]) {
    const loginICPRequired = <any>this.appformatConfigService.parameterConfig?.parameters.ZUGELASSENE_BENUTZERKATEGORIEN === 'REGISTRIERT';
    const noUserPermissions = userPermissions.length === 0;
    const deploymentModePublic = environment.deploymentMode === 'PUBLIC';
    const anonymUserAllowedForRoute = requiredPermissions.some(permission => permission.includes(PermissionsEnum.ANONYM));
    return deploymentModePublic && !loginICPRequired && noUserPermissions && anonymUserAllowedForRoute;
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

}
